module.exports = __webpack_public_path__ + "assets/assets/images/illustrations/family.52545c34.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/illustrations/family.png
// module id = 539
// module chunks = 0